import { NavLink } from 'react-router-dom';
import { Home, LayoutGrid, ShoppingCart, User } from 'lucide-react';
import { useCartStore, useFeature } from '@/app/stores';
import { cartCount } from '@/lib/pricing';
import { cn } from '@/lib/cn';

/** Mobile-only bottom tab bar. */
export function BottomNav() {
  const cartOn = useFeature('cart');
  const catsOn = useFeature('categories');
  const count = useCartStore((s) => cartCount(s.lines));
  const items = [
    { to: '/', label: 'Home', icon: Home, end: true, show: true },
    { to: '/categories', label: 'Categories', icon: LayoutGrid, show: catsOn },
    { to: '/cart', label: 'Cart', icon: ShoppingCart, show: cartOn, badge: count },
    { to: '/account', label: 'Account', icon: User, show: true },
  ].filter((i) => i.show);
  return (
    <nav aria-label="Mobile" className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-card/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-md lg:hidden">
      <ul className="grid" style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}>
        {items.map(({ to, label, icon: Icon, end, badge }) => (
          <li key={to}>
            <NavLink to={to} end={end} className={({ isActive }) => cn('relative flex flex-col items-center gap-0.5 py-2 text-[11px] font-semibold', isActive ? 'text-primary' : 'text-muted-foreground')}>
              <Icon className="size-5" />
              {label}
              {!!badge && <span className="absolute right-[30%] top-1 grid min-w-4 place-items-center rounded-full bg-accent px-1 text-[10px] font-bold leading-4 text-accent-foreground">{badge}</span>}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
